import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Widget from '../../components/widget'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import api from '../../actions/api'
import { toastError, toastSuccess } from '../../actions/toast'
import { handleError } from '../../actions/handle-error'
import DataTable from 'react-data-table-component';
import Loading from '../../components/loading'
import { dateToString } from '../../actions/util';

class Providers extends Component {
  constructor() {
    super()
    this.onDeleteItem = this.onDeleteItem.bind(this)
    this.onConfirmDelete = this.onConfirmDelete.bind(this)

    this.state = {
      data: [],
      modal: false,
      itemDeleteName: null,
      itemDeleteId: null,
      actions: [
        {
          name: 'Novo Fornecedor',
          class_btn: 'btn-success',
          class_collumn: 'col col-md-3',
          route: 'providers/new'
        }
      ]
    }
    this.paginationOptions = { rowsPerPageText: 'Itens por página', rangeSeparatorText: 'de' };

    this.columns = [
      {
        name: 'Nome',
        selector: 'person.name',
        sortable: true,
      },
      {
        name: 'Data Última Venda',
        selector: 'last_purchase_date_format',
        sortable: true,
      },
      {
        name: 'Ações',
        cell: (item) => (
          <div>
            <Link to="#">
              <i className="material-icons text-danger rtd_button" onClick={(e) => this.onConfirmDelete(item)}>delete_forever</i>
            </Link>
          </div>
        ),
        button: true,
      },
    ]
  }

  componentDidMount() {
    this.getProviders();
  }

  getProviders = async () => {
    let providers = [];
    this.setState({ loading: true });

    await api.get('providers')
      .then(result => {
        providers = result.data.map(provider => ({
          ...provider,
          last_purchase_date_format: provider.last_purchase_date ? dateToString(provider.last_purchase_date) : '',
        }))
      })
      .catch(error => {
        toastError(handleError(error));
      })

    this.setState({
      data: providers,
      totalItems: providers.length,
      loading: false,
    });
  }

  onConfirmDelete(item) {
    this.setState({ modal: true, itemDeleteName: item.person.name, itemDeleteId: item.id })
  }

  onDeleteItem = async () => {
    const { itemDeleteId } = this.state;

    await api.delete(`providers/${itemDeleteId}`)
      .then(() => {
        this.getProviders();
        toastSuccess('Registro removido com sucesso!');
        this.setState({ modal: false, itemDeleteId: null, itemDeleteName: null })
      })
      .catch(error => {
        toastError(handleError(error));
      })
  }

  handleRowClicked = reg => {
    this.props.history.push(`/providers/${reg.id}`)
  };

  render() {
    return (
      <Widget title="Fornecedores" actions={this.state.actions} line={false}>
        <div className="row d-flex">
          <div className="col table">
            <DataTable
              columns={this.columns}
              data={this.state.data}
              progressPending={this.state.loading}
              pointerOnHover
              highlightOnHover
              noDataComponent="Nenhum registro encontrado"
              onRowClicked={this.handleRowClicked}
              progressComponent={<Loading />}
            />
          </div>
        </div>

        <Modal
          isOpen={this.state.modal}
          wrapClassName="modal-danger"
          size="default">
          <ModalHeader toggle={this.toggle}>Deletar Registro</ModalHeader>
          <ModalBody>
            Deseja excluir {this.state.itemDeleteName} ?
            </ModalBody>
          <ModalFooter>
            <button className="btn btn-success col-4" onClick={this.onDeleteItem}>
              Sim
              </button>
            <button className="btn btn-success" onClick={event => this.setState({ modal: false, itemDeleteId: null, itemDeleteName: null })}>
              Cancelar
              </button>
          </ModalFooter>
        </Modal>
      </Widget>
    )
  }
}

export default Providers